import { useEffect, useState } from "react";
import Alerts from "../../reusableComponents/alert";
import FilesList from "../../reusableComponents/filesList";
import FileUploader from "../../reusableComponents/fileUploader";
import DateInput from "../../sharedComponents/datesInputs/date";
import { useFormik } from "formik";
import {
  formikSetup,
  formikValidation,
  initialValues,
  validationSchema,
} from "../formikValidation";
import Lang from "../../../userPreferences/staticWords";
import {
  addProcedure,
  addSubTaskComment,
  addSubTaskProcedure,
  getAllMemberInTask,
} from "../../../API/store/actions/procedure/procedure";
import Button from "../../sharedComponents/buttons/button";
import TextArea from "../../sharedComponents/textarea/textArea";
import { useDispatch, useSelector } from "react-redux";
import { resolver } from "../../../API/middlewares/resolveRequests";
import {
  getAllProjectStatus,
  getCreateActivityProcedureForm,
} from "../../../API/store/actions/projects/projects";
import { addActivityProcedureForm } from "./../../../API/services/projects/project";
import * as actionTypes from "../../../API/store/actions/actionTypes";
import { getAllTaskStatus } from "../../../API/store/actions/tasks";
import DropDownList from "../../sharedComponents/dropdown/dropdown";
import { englishDate } from "../../../algorithms";
import {
  getCurrentLangFromRedux,
  getDir,
} from "../../../algorithms/styleChanges";

const AddCommentForm = ({
  taskprocedureId,
  setVisible,
  setProcAdded,
  procAdded,
  userToken,
  activityId,
  subTaskId,
}) => {
  const [files, setFiles] = useState([]);
  const [duplicateAlert, setDuplicateAlert] = useState(false);
  const [noFilesAlert, setNoFilesAlert] = useState(false);
  const [error, setError] = useState(false);

  const user = useSelector((state) => state.login.userData);
  const dispatch = useDispatch();

  const [disable, setDisable] = useState(false);
  const submit = async (values) => {
    let formData = new FormData();
    const newTaskData = {
      Description: values.Description,
      MemberId: user.memberId,
      UserId: user.id,
      //   files: values.files,
    };

    for (let [key, value] of Object.entries(newTaskData)) {
      if (key == "files" && values.files) {
        value.forEach((element) => {
          formData.append("files", element.file);
        });
      } else {
        formData.append(key, value);
      }
    }
    // if (validDate) {
    // if (files.length) {
    //   setError(false);
    if (disable) {
      return;
    } else {
      setDisable(true);
    }
    let res;
    res = await addSubTaskComment(taskprocedureId, formData, userToken);
    if (res.status <= 206) {
      dispatch({ type: actionTypes.RELOAD });
      setProcAdded(!procAdded);
      setFiles([]);
      resetForm();
      setVisible(false);
      setDisable(false);
    } else {
      setDisable(false);
    }
    // } else {
    //   setError(true);
    // }
    // }
  };

  const formik = useFormik(
    formikSetup(
      initialValues,
      0,
      validationSchema,
      `${activityId ? "addActivityProcedure" : "addProcedure"}`,
      submit,
    ),
  );
  const {
    errors,
    touched,
    handleSubmit,
    handleChange,
    setFieldValue,
    values,
    resetForm,
    setFieldTouched,
  } = formik;

  return (
    <>
      <form id="addProcedure" onSubmit={handleSubmit}>
        <div className="d-flex flex-wrap justify-content-around">
          <TextArea
            name={"Description"}
            value={values.Description}
            onChange={handleChange}
            errorMessage={formikValidation(touched, errors, "Description")}
            placeholder={Lang.Description + "*"}
            containerStyle={"col-10  mt-4"}
            rows={4}
          ></TextArea>

          <Alerts
            variant={"danger"}
            buttonContent={
              getDir(getCurrentLangFromRedux()) == "rtl" ? "إغلاق" : "close"
            }
            content={
              getDir(getCurrentLangFromRedux()) == "rtl"
                ? "هذا الملف تم رفعه من قبل"
                : "this file uploaded already"
            }
            title={
              getDir(getCurrentLangFromRedux()) == "rtl"
                ? "ملف متكرر"
                : "duplicate file"
            }
            show={duplicateAlert}
            setShow={setDuplicateAlert}
          />
          <Alerts
            variant={"danger"}
            buttonContent={
              getDir(getCurrentLangFromRedux()) == "rtl" ? "إغلاق" : "close"
            }
            content={
              getDir(getCurrentLangFromRedux()) == "rtl"
                ? "برجاء رفع بعض الملفات"
                : "please upload some files"
            }
            title={
              getDir(getCurrentLangFromRedux()) == "rtl"
                ? "لا يوجد ملفات"
                : "No Files Here"
            }
            show={noFilesAlert}
            setShow={setNoFilesAlert}
          />

          {/* <FileUploader
            containerStyle={"col-10 mt-3"}
            contentStyle={"col-12"}
            borderColor={"#C7C7C9"}
            placeholderLTRWidth={150}
            placeholderRTLWidth={115}
            fileIconColor={"#1a73e8"}
            fileValue={values.file}
            fileOnClick={(e) => {
              e.target.value = "";
              setFieldValue("file", e.target.value);
            }}
            FileOnChange={(e) => {
              setFieldValue("file", e.target.files[0]);
            }}
            uploadButtonOnChange={() => {
              if (values.file) {
                if (
                  !files.find(
                    (item) => item.fileName === values.file.name.substr(0, 35)
                  )
                ) {
                  const allFiles = [
                    ...files,
                    {
                      id: files.length + 1,
                      fileName: values.file.name.substr(0, 35),
                      file: values.file,
                    },
                  ];
                  setFieldValue("files", [...allFiles]);
                  setFiles([...allFiles]);
                  setFieldValue("file", "");
                  setFieldTouched("files", false);
                  // setError(false);
                } else {
                  setDuplicateAlert(true);
                  setTimeout(() => {
                    setDuplicateAlert(false);
                  }, 1000);
                }
              } else {
                setNoFilesAlert(true);
                setTimeout(() => {
                  setNoFilesAlert(false);
                }, 1000);
              }
            }}
          />
          <FilesList
            containerStyle={"col-10 justify-content-around"}
            contentStyle={"col-12"}
            Data={[...files]}
            setFiles={setFiles}
            setFilesInFormik={setFieldValue}
            setFilesTouched={setFieldTouched}
            // error={error}
            // setError={setError}
            propInFormik={"files"}
          /> */}
          <div className="d-flex justify-content-around align-items-center my-3 col-10">
            <Button
              containerStyle={"col-4"}
              type={"submit"}
              // onClick={() => {
              //   if (files.length > 0) setError(false);
              //   else setError(true);
              // }}
              disable={disable}
              content={disable ? Lang.saving : Lang.save}
              buttonStyleType={"solid"}
            />
            <Button
              content={Lang.cancel}
              containerStyle={"col-4"}
              onClick={() => {
                setVisible(false);
              }}
            />
          </div>
        </div>
      </form>
    </>
  );
};

export default AddCommentForm;
